import { accentColors, lighterVariations } from '@tryhackme/thm-ui-components';
import certificatesImage from 'src/images/pngs/campaigns/flash-sale/certificates.png';
import styled, { css } from 'styled-components';

export const StyledBanner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1.6rem;
  min-height: 65.5rem;
  padding: 3rem 1.8rem 18rem;
  position: relative;
  overflow: hidden;
  z-index: 0;
  background: ${({ theme }) => theme.colors.offBlack};

  &::after {
    content: '';
    position: absolute;
    right: -5.2rem;
    bottom: -4.2rem;
    width: 43.8rem;
    height: 26.8rem;
    border-radius: 86.8rem;
    background: radial-gradient(50% 50% at 50% 50%, rgba(77, 37, 89, 0.54) 0%, rgba(77, 37, 89, 0.32) 55%, rgba(77, 37, 89, 0.00) 100%);
    pointer-events: none;
    z-index: -1;
  }

  @media screen and (min-width: 576px) {
    min-height: 37.7rem;
    padding: 4.6rem;
  }

  & > div {
    z-index: 10;
  }
`;

export const StyledTitle = styled.h2`
  color: ${({ theme }) => theme.colors.text.main};
  letter-spacing: -0.96px;
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  margin-bottom: 0rem;

  font-size: ${({ theme }) => theme.fonts.sizes.subTitle};
  text-align: left;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
  }

  @media screen and (max-width: 576px) {
    max-width: 100%;
  }
`;

export const StyledSubTitle = styled.h3`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 0rem;

  text-align: left;
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  max-width: 45.1rem;

  span {
    color: ${({ theme }) => theme.colors.primary.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  }

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.default};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    line-height: 2rem;
    max-width: 100%;
  }
`;

export const StyledSubTitleAlt = styled(StyledSubTitle)`
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  line-height: 3rem;
  max-width: 100%;

  @media screen and (max-width: 576px) {
    font-size: ${({ theme }) => theme.fonts.sizes.medium};
    line-height: 2.3rem;
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  gap: 1.6rem;
`;

export const StyledCountdownContainer = styled.div`
  padding: 0.8rem 0rem 0rem;
`;
export const StyledCertificatesImage = styled.img.attrs({
  src: certificatesImage,
})<{ $large: boolean }>`
  position: absolute;
  z-index: 1;
  width: 26.4rem;

  ${({ $large }) =>
    $large
      ? css`
    right: 0rem;
    bottom: 50%;
    transform: translateY(50%);
  `
      : css`
    bottom: 0.8rem;
    right: 2.9rem;
    transform: none;
  `}

  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    bottom: 0.8rem;
    right: 2.9rem;
    transform: none;
  }

  @media screen and (max-width: ${({ theme }) => theme.sizes.md}) {
    right: 3rem;
    bottom: 1.2rem;
    transform: none;
  }

  @media screen and (max-width: 576px) {
    bottom: 0;
    right: 50%;
    transform: translateX(50%);
  }
`;

export const StyledBadgeMessage = styled.div`
  background-color: ${lighterVariations.blue.darker};
  color: ${accentColors.info.dark};
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  border-radius: 1rem;
  padding: 0.2rem 1rem;
`;
